import { DateTime } from 'luxon';
import { AppointmentServiceModel } from './appointment-service-model';


export class CustomerLastAppointment {
  id: string;  
  customerId: string;
  startDate: DateTime;
  services: AppointmentServiceModel[];
  notes: string;
  evolutionNotes: string[];

  constructor(x?: any) {
    if (typeof x == "object") {
      this.id = x.id;
      this.customerId = x.customerId;
      this.startDate = DateTime.fromISO(x.startDate);
      this.services = x.services;
      this.notes = x.notes;
      this.evolutionNotes = x.evolutionNotes;
    } else {
      this.id = "";
      this.customerId = "";
      this.startDate = DateTime.now();  
      this.services = [];
      this.notes = "";
      this.evolutionNotes = [];
    }
  }
}
